import {Component, tag} from 'doz';
import logoUrlRect from '../../../resources/default-cover.png';
import arraySort from "array-sort";
import ellipsis from 'text-ellipsis';

@tag('podcasts')
export default class extends Component {
    props = {
        //feedUrl: '',
        feed: [],
        sidePadding: true,
        //maxFeed: 5,
        defaultCoverUrl: logoUrlRect
    };

    template(h) {
        //language=HTML
        return h`
            <style>
                .container{
                    color: ${this.THEME.primaryColor};
                    background: ${this.PLAYER_CONFIG.newsBackgroundColor || this.THEME.onPrimaryColor};
                    border-color: ${this.PLAYER_CONFIG.newsSeparatorColor || ''};
                    text-align:left;
                    min-height: 250px;
                    overflow: hidden;
                    padding-left: 0;
                    padding-right: 0;
                    padding-bottom: 64px;
                }

                .swiper {
                    padding-right: 64px;
                }

                .swiper-wrapper {
                    padding-left: 32px;
                    position: relative;
                }
                
                .link-wrapper {
                    position: relative;
                    display: block;
                    margin-bottom: 8px;
                }
                
                .img{
                    width: 100%;
                    height: auto;
                    object-fit: cover;
                    object-position: center;
                    border-radius: 8px;
                    display: block;
                    aspect-ratio: 1 / 1;
                }
                
                .masked{
                    clip-path: polygon(0 0, 100% 0, 100% calc(100% - 30px), 0 100%);
                    -webkit-clip-path: polygon(0 0, 100% 0, 100% calc(100% - 30px), 0 100%);
                }
                   
                .row {
                    /*border-bottom: 1px dotted ${this.PLAYER_CONFIG.newsArticleSeparatorColor || this.THEME.primaryColorDark};
                    padding: 24px 0;*/
                }
                
                /*.row:nth-child(2) {*/
                /*   padding-top: 24px !important;*/
                /*}*/
                
                .row:last-child {
                    border: none;
                    padding-bottom: 0;
                }
                
                .layout-horizontal.row{
                    display: flex;
                } 
                
                .layout-horizontal.row .img{
                    width: 100px;
                    height: 100px;
                    margin-right: 14px;
                } 
                
                .layout-horizontal.row p{
                    font-size: 14px;
                } 
                
                .date {
                    font-size: 11px; 
                    color:${this.PLAYER_CONFIG.newsArticleDateColor || this.THEME.primaryColorDark}; 
                    text-transform: capitalize;
                    margin-bottom: 4px;
                    display: none;
                }

                .seriesName {
                    font-size: 12px;
                    margin-top: 0;
                    margin-bottom: 4px;
                    display: none;
                }
                
                .title {
                    margin: 0; 
                    font-size: 14px; 
                    color: ${this.PLAYER_CONFIG.newsArticleTitleColor || this.THEME.primaryColor};
                }
                
                .link {
                    color: ${this.PLAYER_CONFIG.newsArticleLinkColor || this.THEME.primaryColorDark}; 
                    text-decoration: none; 
                    font-size: 11px;
                }
                
                h3 {
                    color: ${this.PLAYER_CONFIG.newsTitleColor || this.THEME.primaryColor};
                }
                
                .play {
                    position: absolute;
                    width: 50px;
                    height: 50px;
                    display: flex;
                    bottom: 4px;
                    right: 4px;
                    align-items: center;
                    justify-content: center;
                    color: #fff;
                    font-size: 32px;
                    background: rgba(0,0,0,.3);
                    border-radius: 8px;
                }
            </style>
            <div class="container">
                <h3>${this.PLAYER_CONFIG.podcastTitleText || 'Podcast'}</h3>
                <div d-ref="slide" class="swiper"> 
                    <div class="swiper-wrapper">
                        ${this.each(this.props.feed,item =>h`
                            <div class="swiper-slide -row -animated -fadeIn ${this.PLAYER_CONFIG.newsFeedType === 'LAYOUT_2' ? 'layout-horizontal' : ''}">
                                <a class="link-wrapper" href="${item.link}" target="_blank">
                                    <div class="play"><i class="fal fa-play"></i></div>
                                    <img class="img" loading="lazy" onload="${(e) => e.target.parentElement.nextElementSibling.style.visibility = 'visible'}" src="${item.image ? item.image : item.categoryImage ? item.categoryImage : this.props.defaultCoverUrl}">
                                </a>
                                <div class="content" style="visibility: hidden">
                                    <span class="date">
                                        ${new Date(item.pubTimestamp).toLocaleDateString('it-IT', {year: 'numeric', month: 'long',day: 'numeric'})}
                                    </span>
                                    <h2 class="seriesName">${ellipsis(item.seriesName)}</h2>
                                    <p class="title">${ellipsis(item.title, 50)}</p>
                                </div>
                            </div>
                         `)}
                    </div>
                </div>    
            </div>
        `
    }

    onMount(){
        this.getFeed();
        if (!this.isSSR()) {
            setInterval(() => this.getFeed(), 60000 * 5);
            this.swiperInstance = new Swiper(this.ref.slide, {
                slidesPerView: 2.3,
                spaceBetween: 32,
                freeMode: true,
                breakpoints: {
                    640: {
                        slidesPerView: 4,
                    }
                }
            });
        }
    }

    onMountAsync() {
        //if (this.isSSR()) return;

    }

    getFeed(){
        this.axios.get(this.PLAYER_CONFIG.podcastsFeedsUrl)
            .then(result => {
                if (result.data.success) {
                    let records = [];
                    for (let i in result.data.result.items) {
                        let episodes = result.data.result.items[i];
                        for (let x = 0; x < 1 /*episodes.length*/; x++) {
                            let episode = episodes[x];
                            episode.seriesName = i;
                            records.push(episode);
                        }
                    }
                    this.props.feed = arraySort(records, 'pubTimestamp', {reverse: true}).slice(0, 20);
                }
            })
            .catch(e => console.log(e))
    }
}